/**
 * Dots Loader
 * Dot style loader used on the full page loading screen
 */
import React from 'react';

import { LoaderStyle } from './Dots.style';

const Loader: React.FC<{ size: string }> = ({ size = '11px' }) => {
  return (
    <LoaderStyle size={size}>
      <div data-testid="dots-div" />
      <div />
      <div />
      <div />
    </LoaderStyle>
  );
};

export default Loader;
